// extracted by mini-css-extract-plugin
export var standaloneTable = "_hy-0";
export var standaloneTableWithBodyFill = "_hy-1";
export var withExtraHeader = "_hy-2";